import type { JSX } from "react";
import { FC } from "react";
import styled from "styled-components";
import { color } from "@styles";
import { P1 } from "./Paragraph";
import { Tooltip } from "./Tooltip";
import { mobile } from "components/templates/Breakpoints";

export interface StatBoxProps {
  stat?: string;
  statColor?: string;
  copy: string | JSX.Element;
  copyColor?: string;
  tooltip?: string;
  boxWidth?: string;
}

export const StatBox: FC<StatBoxProps> = ({
  stat,
  statColor,
  copy,
  copyColor,
  tooltip,
  boxWidth,
}) => {
  return (
    <Box width={boxWidth}>
      <Flex>
        {stat && <Stat color={statColor}>{stat}</Stat>}
        {typeof copy === "string" ? <Copy color={copyColor}>{copy}</Copy> : copy}
        {tooltip && (
          <TooltipWrap>
            <Tooltip
              iconPositioning={{ top: ".3rem", left: ".5rem" }}
              infoBoxPositioning={{ left: "-8.25rem", bottom: "0.1rem" }}
              tipPositioning={{ top: "99%" }}
              inverted
            >
              {tooltip}
            </Tooltip>
          </TooltipWrap>
        )}
      </Flex>
    </Box>
  );
};

const Box = styled.div<{
  width?: string;
}>`
  display: inline-block;
  padding: 1rem 1.5rem;
  border: 0.125rem solid ${color.B240};
  box-shadow: 0.5rem 0.5rem 0px ${color.B220};
  border-radius: 0.5rem;
  width: ${(p) => (p.width ? p.width : "auto")};

  ${mobile} {
    width: 100%;
  }
`;

const Flex = styled.div`
  display: flex;

  ${mobile} {
    align-items: center;
  }
`;

const Stat = styled(P1)`
  font-size: 2rem;
  font-weight: 700;
  margin-right: 0.5rem;
  padding-top: 0;
`;

const Copy = styled(P1)`
  font-size: 0.9rem;
  line-height: 1.8rem;
  padding-top: 0;
  letter-spacing: 0.0125rem;

  ${mobile} {
    padding-left: 0.2rem;
    line-height: normal;
  }
`;

const TooltipWrap = styled.div`
  position: relative;
  padding-right: 1.2rem;

  ${mobile} {
    display: none;
  }
`;
